import { Button, UIHeading1, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './BrokerFlightBanner.css';
import { NO_BREAK_SPACE } from '../../constants/symbolsUnicode';

interface IBrokerConsultantBannerProps {
  url?: string;
  buttonText?: string;
  buttonLoading?: boolean;
  onClick?: () => void;
}

// TODO: В случае победы эксперимента в CD-243910 заменить a на section, а в случае проигрыша лишние пропсы.
export const BrokerFlightBanner: React.FC<IBrokerConsultantBannerProps> = ({
  url,
  buttonText = 'Давайте поподробнее',
  buttonLoading = false,
  onClick,
}) => {
  return (
    <a href={url} target="_blank" rel="noreferrer" className={styles['container']} data-testid="BrokerFlightBanner">
      <div className={styles['inner']}>
        <UIHeading1 color="text-inverted-default">
          Подберём и{NO_BREAK_SPACE}поможем купить квартиру в{NO_BREAK_SPACE}новостройке. Бесплатно!
        </UIHeading1>
        <div className={styles['description-wrapper']}>
          <UIText1 color="text-inverted-default">
            Найдём тот{NO_BREAK_SPACE}самый вариант под{NO_BREAK_SPACE}ваш{NO_BREAK_SPACE}бюджет
          </UIText1>
        </div>
        <div>
          <Button theme="fill_white_primary" loading={buttonLoading} onClick={onClick}>
            {buttonText}
          </Button>
        </div>
      </div>
    </a>
  );
};
